import React from 'react';

interface IMappingRowDataTypeProps {
  dataType: string;
}

export function MappingRowDataType(props: IMappingRowDataTypeProps) {
  return (
    <div className={`dp-flow-mapping-row__datatype`} title={props.dataType}>
      {props.dataType}
    </div>
  );
}
